import { createApp } from 'vue'
import FadeIn from '~/js/components/fadeIn'

const CLASS_NAME_TEIKIBIN_POINT_ITEM = 'js-teikibin-point-item'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinPointItem = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_POINT_ITEM
  )
  if (!elementsTeikibinPointItem.length) return

  Array.from(elementsTeikibinPointItem).forEach((element) => {
    createApp({
      name: 'BlocksTeikibinPointItem',
      components: {
        FadeIn,
      },
    }).mount(element)
  })
})
